import React from "react";
import { TbCircle } from "react-icons/tb";
import { TbCircleCheckFilled } from "react-icons/tb";
import moment from "moment";


export default function Component(props) {
  const {
    handleTestSelect,
    handleTestClick,
    getTestModuleData,
    crrSurveyId,
    isTrue,
    handleViewReport
  } = props;




  // function getSecondsToTime(given_seconds) {
  //   var seconds = parseInt(given_seconds);
  //   var format =
  //     (Math.floor(moment.duration(seconds, "seconds").asHours()) < 10
  //       ? Math.floor(moment.duration(seconds, "seconds").asHours())
  //       : Math.floor(moment.duration(seconds, "seconds").asHours())) +
  //     ":" +
  //     (moment.duration(seconds, "seconds").minutes() < 10
  //       ? "0" + moment.duration(seconds, "seconds").minutes()
  //       : moment.duration(seconds, "seconds").minutes()) +
  //     ":" +
  //     (moment.duration(seconds, "seconds").seconds() < 10
  //       ? "0" + moment.duration(seconds, "seconds").seconds()
  //       : moment.duration(seconds, "seconds").seconds());
  //   return format;
  // }


  // function getIcon(name) {
  //   if (name === "Interest Assessment Test") {
  //     return "./img/surveylink/holland-test.svg"
  //   } else if (name === "Personality Assessment Test") {
  //     return "./img/surveylink/personality-test.svg"
  //   } else if (name === "Work Value Survey") {
  //     return "./img/surveylink/work-value-test.svg"
  //   } else if (name === "Aptitude Test") {
  //     return "./img/surveylink/aptitude-test.svg"
  //   }
  // }

  function getIcon(type) {
    if (type === 4) {
      return "./img/surveylink/aptitude-test.svg"
    } else if (type === 2) {
      return "./img/surveylink/holland-test.svg"
    } else if (type === 1) {
      return "./img/surveylink/personality-test.svg"
    } else if (type === 3) {
      return "./img/surveylink/work-value-test.svg"
    }
  }

  let showContinue = 0;
  let count = 0;
  if (getTestModuleData && getTestModuleData.length > 0) {
    for (var i = 0; i < getTestModuleData.length; i++) {
      let item = getTestModuleData[i];
      if (item && item.isComplete) {
        count++
      }
      if (crrSurveyId === item.surveyId) {
        showContinue = 1;
        break;
      }
    }

    if (getTestModuleData.length === count) {
      showContinue = 2;
    }
  }

  function getTime(seconds) {
    let sec = 0;
    if (seconds) {
      sec = seconds / 60;
    }
    return sec.toString()
  }
  // Predefined order array
  const order = [4, 1, 2, 3];

  // Sort the getTestModuleData based on the predefined order
  const sortedTestModuleData = getTestModuleData ? getTestModuleData.sort((a, b) => order.indexOf(a.type) - order.indexOf(b.type)) : [];

  return (

    <>
      <div className="w-full h-[calc(100vh-4rem)] overflow-y-auto">
        <section className="px-4 py-4 mx-auto space-y-6 2xl:w-6/12 lg:w-8/12 md:py-6 lg:px-0 lg:space-y-10">
          <div className="space-y-2 text-center lg:pt-4">
            <h1 className=" text-2xl font-semibold left 2xl:text-4xl xl:text-2xl text-[#212121] " >
              Career Assessment
            </h1>
            <p className="lg:text-lg text-base text-[#212121]">Choose a test you like to start with</p>
          </div>
          <div className="w-full space-y-4   ">
            <div className='flex items-center space-x-2 p-2 px-4 rounded-sm bg-[#F5EBCE]'>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 36 36" fill="none">
                <rect width="36" height="36" rx="4" fill="#FFC107" />
                <g clip-path="url(#clip0_5553_661)">
                  <path d="M19.3001 9.14844L27.9342 24.1024C28.0658 24.3305 28.1351 24.5891 28.1351 24.8524C28.1351 25.1157 28.0658 25.3744 27.9342 25.6024C27.8025 25.8304 27.6132 26.0198 27.3851 26.1515C27.1571 26.2831 26.8985 26.3524 26.6352 26.3524H9.36715C9.10385 26.3524 8.84519 26.2831 8.61716 26.1515C8.38914 26.0198 8.19979 25.8304 8.06814 25.6024C7.93649 25.3744 7.86719 25.1157 7.86719 24.8524C7.86719 24.5891 7.9365 24.3305 8.06815 24.1024L16.7021 9.14844C17.2791 8.14844 18.7221 8.14844 19.3001 9.14844ZM18.0011 10.8984L10.2331 24.3524H25.7691L18.0011 10.8984ZM18.0011 21.0004C18.2664 21.0004 18.5207 21.1058 18.7083 21.2933C18.8958 21.4809 19.0011 21.7352 19.0011 22.0004C19.0011 22.2657 18.8958 22.52 18.7083 22.7075C18.5207 22.8951 18.2664 23.0004 18.0011 23.0004C17.7359 23.0004 17.4816 22.8951 17.294 22.7075C17.1065 22.52 17.0011 22.2657 17.0011 22.0004C17.0011 21.7352 17.1065 21.4809 17.294 21.2933C17.4816 21.1058 17.7359 21.0004 18.0011 21.0004ZM18.0011 14.0004C18.2664 14.0004 18.5207 14.1058 18.7083 14.2933C18.8958 14.4809 19.0011 14.7352 19.0011 15.0004V19.0004C19.0011 19.2657 18.8958 19.52 18.7083 19.7075C18.5207 19.8951 18.2664 20.0004 18.0011 20.0004C17.7359 20.0004 17.4816 19.8951 17.294 19.7075C17.1065 19.52 17.0011 19.2657 17.0011 19.0004V15.0004C17.0011 14.7352 17.1065 14.4809 17.294 14.2933C17.4816 14.1058 17.7359 14.0004 18.0011 14.0004Z" fill="white" />
                </g>
                <defs>
                  <clipPath id="clip0_5553_661">
                    <rect width="24" height="24" fill="white" transform="translate(6 6)" />
                  </clipPath>
                </defs>
              </svg>
              <p className="text-sm font-medium text-[#212121]">* All test are mandatory</p>
            </div>
            <div className="grid grid-cols-1 gap-4">

              {sortedTestModuleData && sortedTestModuleData.length > 0
                ? sortedTestModuleData.map((item, index) =>
                  <>
                    {item && item.isComplete ? (
                      <div key={item.index}
                        className="cursor-pointer lg:p-6 p-4 rounded-2xl bg-[#E8F5E9] border border-[#4CAF50] flex md:items-center space-x-4   justify-between  " >
                        <div className='flex flex-col gap-4 md:flex-row md:items-start '>
                          <img src={getIcon(item.type)} className="w-20 lg:w-24" />
                          <div className="space-y-2 ">
                            <h2 className="text-lg font-semibold lg:text-xl">{item.name}</h2>
                            <p className="text-base">{item.desc}</p>
                            <div className="flex items-center pt-4 space-x-2">
                              <div className='flex items-center space-x-1'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 31 30" fill="none">
                                  <g clip-path="url(#clip0_5561_908)">
                                    <path d="M15.1758 2.5C22.0795 2.5 27.6758 8.09625 27.6758 15C27.6758 21.9037 22.0795 27.5 15.1758 27.5C8.27203 27.5 2.67578 21.9037 2.67578 15C2.67578 8.09625 8.27203 2.5 15.1758 2.5ZM15.1758 5C12.5236 5 9.98008 6.05357 8.10471 7.92893C6.22935 9.8043 5.17578 12.3478 5.17578 15C5.17578 17.6522 6.22935 20.1957 8.10471 22.0711C9.98008 23.9464 12.5236 25 15.1758 25C17.8279 25 20.3715 23.9464 22.2468 22.0711C24.1222 20.1957 25.1758 17.6522 25.1758 15C25.1758 12.3478 24.1222 9.8043 22.2468 7.92893C20.3715 6.05357 17.8279 5 15.1758 5ZM15.1758 20C15.5073 20 15.8252 20.1317 16.0597 20.3661C16.2941 20.6005 16.4258 20.9185 16.4258 21.25C16.4258 21.5815 16.2941 21.8995 16.0597 22.1339C15.8252 22.3683 15.5073 22.5 15.1758 22.5C14.8443 22.5 14.5263 22.3683 14.2919 22.1339C14.0575 21.8995 13.9258 21.5815 13.9258 21.25C13.9258 20.9185 14.0575 20.6005 14.2919 20.3661C14.5263 20.1317 14.8443 20 15.1758 20ZM15.1758 8.125C16.2286 8.12503 17.2486 8.49169 18.0605 9.162C18.8724 9.83231 19.4256 10.7644 19.6249 11.7982C19.8243 12.832 19.6574 13.903 19.153 14.8271C18.6486 15.7513 17.8381 16.471 16.8608 16.8625C16.7168 16.9172 16.5866 17.003 16.4795 17.1138C16.4245 17.1763 16.4158 17.2563 16.417 17.3388L16.4258 17.5C16.4254 17.8186 16.3034 18.125 16.0847 18.3567C15.866 18.5884 15.5671 18.7278 15.249 18.7465C14.931 18.7651 14.6178 18.6617 14.3735 18.4572C14.1292 18.2527 13.9722 17.9626 13.9345 17.6462L13.9258 17.5V17.1875C13.9258 15.7463 15.0883 14.8812 15.9308 14.5425C16.2737 14.4056 16.5728 14.1778 16.796 13.8837C17.0192 13.5896 17.1581 13.2403 17.1978 12.8732C17.2374 12.5061 17.1763 12.1352 17.0211 11.8002C16.8658 11.4652 16.6222 11.1788 16.3165 10.9718C16.0107 10.7649 15.6544 10.6451 15.2857 10.6253C14.917 10.6056 14.5499 10.6867 14.2238 10.8598C13.8977 11.033 13.6249 11.2917 13.4348 11.6082C13.2446 11.9247 13.1443 12.287 13.1445 12.6562C13.1445 12.9878 13.0128 13.3057 12.7784 13.5401C12.544 13.7746 12.2261 13.9062 11.8945 13.9062C11.563 13.9062 11.2451 13.7746 11.0106 13.5401C10.7762 13.3057 10.6445 12.9878 10.6445 12.6562C10.6445 11.4545 11.1219 10.3019 11.9717 9.45217C12.8215 8.6024 13.974 8.125 15.1758 8.125Z" fill="#212121" />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_5561_908">
                                      <rect width="30" height="30" fill="white" transform="translate(0.175781)" />
                                    </clipPath>
                                  </defs>
                                </svg>
                                <p className="text-sm lg:text-base" >{item.questionCount} Questions</p>
                              </div>
                              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                                <circle cx="3.17578" cy="3.58789" r="3" fill="#212121" />
                              </svg>
                              <div className='flex items-center space-x-1'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 31 31" fill="none">
                                  <path d="M15.1758 26.8379C21.389 26.8379 26.4258 21.8011 26.4258 15.5879C26.4258 9.37469 21.389 4.33789 15.1758 4.33789C8.96258 4.33789 3.92578 9.37469 3.92578 15.5879C3.92578 21.8011 8.96258 26.8379 15.1758 26.8379Z" stroke="#212121" strokeWidth="2" strokeLinecap="round" stroke-linejoin="round" />
                                  <path d="M13.9258 10.5879V16.8379H20.1758" stroke="#212121" strokeWidth="2" strokeLinecap="round" stroke-linejoin="round" />
                                </svg>
                                <p className="text-sm lg:text-base" >{getTime(item.seconds)} Min</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="w-8 h-8 rounded-full bg-[#4CAF50] items-center justify-center flex text-white flex-shrink-0">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-check"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M5 12l5 5l10 -10" /></svg>
                        </div>
                        {/* <TbCircleCheckFilled className="lg:text-[3rem] text-[2rem] text-[#2196f3] flex-shrink-0" /> */}
                      </div>
                    ) : (
                      <div onClick={() => handleTestSelect(item)} key={item.index} className="flex justify-between p-4 space-x-4 bg-white border cursor-pointer lg:p-6 rounded-2xl md:items-center" >
                        <div className='flex flex-col gap-4 md:flex-row md:items-start '>
                          {/* <img src='./img/surveylink/reality-test.svg' className="w-20 lg:w-28" /> */}
                          <img src={getIcon(item.type)} className="w-20 lg:w-24" />
                          <div className="space-y-2 ">
                            <h2 className="text-lg font-semibold lg:text-xl">{item.name}</h2>
                            <p className="text-base">{item.desc}</p>
                            <div className="flex items-center pt-2 space-x-2">
                              <div className='flex items-center space-x-1'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 31 30" fill="none">
                                  <g clip-path="url(#clip0_5561_908)">
                                    <path d="M15.1758 2.5C22.0795 2.5 27.6758 8.09625 27.6758 15C27.6758 21.9037 22.0795 27.5 15.1758 27.5C8.27203 27.5 2.67578 21.9037 2.67578 15C2.67578 8.09625 8.27203 2.5 15.1758 2.5ZM15.1758 5C12.5236 5 9.98008 6.05357 8.10471 7.92893C6.22935 9.8043 5.17578 12.3478 5.17578 15C5.17578 17.6522 6.22935 20.1957 8.10471 22.0711C9.98008 23.9464 12.5236 25 15.1758 25C17.8279 25 20.3715 23.9464 22.2468 22.0711C24.1222 20.1957 25.1758 17.6522 25.1758 15C25.1758 12.3478 24.1222 9.8043 22.2468 7.92893C20.3715 6.05357 17.8279 5 15.1758 5ZM15.1758 20C15.5073 20 15.8252 20.1317 16.0597 20.3661C16.2941 20.6005 16.4258 20.9185 16.4258 21.25C16.4258 21.5815 16.2941 21.8995 16.0597 22.1339C15.8252 22.3683 15.5073 22.5 15.1758 22.5C14.8443 22.5 14.5263 22.3683 14.2919 22.1339C14.0575 21.8995 13.9258 21.5815 13.9258 21.25C13.9258 20.9185 14.0575 20.6005 14.2919 20.3661C14.5263 20.1317 14.8443 20 15.1758 20ZM15.1758 8.125C16.2286 8.12503 17.2486 8.49169 18.0605 9.162C18.8724 9.83231 19.4256 10.7644 19.6249 11.7982C19.8243 12.832 19.6574 13.903 19.153 14.8271C18.6486 15.7513 17.8381 16.471 16.8608 16.8625C16.7168 16.9172 16.5866 17.003 16.4795 17.1138C16.4245 17.1763 16.4158 17.2563 16.417 17.3388L16.4258 17.5C16.4254 17.8186 16.3034 18.125 16.0847 18.3567C15.866 18.5884 15.5671 18.7278 15.249 18.7465C14.931 18.7651 14.6178 18.6617 14.3735 18.4572C14.1292 18.2527 13.9722 17.9626 13.9345 17.6462L13.9258 17.5V17.1875C13.9258 15.7463 15.0883 14.8812 15.9308 14.5425C16.2737 14.4056 16.5728 14.1778 16.796 13.8837C17.0192 13.5896 17.1581 13.2403 17.1978 12.8732C17.2374 12.5061 17.1763 12.1352 17.0211 11.8002C16.8658 11.4652 16.6222 11.1788 16.3165 10.9718C16.0107 10.7649 15.6544 10.6451 15.2857 10.6253C14.917 10.6056 14.5499 10.6867 14.2238 10.8598C13.8977 11.033 13.6249 11.2917 13.4348 11.6082C13.2446 11.9247 13.1443 12.287 13.1445 12.6562C13.1445 12.9878 13.0128 13.3057 12.7784 13.5401C12.544 13.7746 12.2261 13.9062 11.8945 13.9062C11.563 13.9062 11.2451 13.7746 11.0106 13.5401C10.7762 13.3057 10.6445 12.9878 10.6445 12.6562C10.6445 11.4545 11.1219 10.3019 11.9717 9.45217C12.8215 8.6024 13.974 8.125 15.1758 8.125Z" fill="#212121" />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_5561_908">
                                      <rect width="30" height="30" fill="white" transform="translate(0.175781)" />
                                    </clipPath>
                                  </defs>
                                </svg>
                                <p className="text-sm lg:text-base" >{item.questionCount} Questions</p>
                              </div>
                              <svg xmlns="http://www.w3.org/2000/svg" width="5" height="5" viewBox="0 0 7 7" fill="none">
                                <circle cx="3.17578" cy="3.58789" r="3" fill="#212121" />
                              </svg>
                              <div className='flex items-center space-x-1'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 31 31" fill="none">
                                  <path d="M15.1758 26.8379C21.389 26.8379 26.4258 21.8011 26.4258 15.5879C26.4258 9.37469 21.389 4.33789 15.1758 4.33789C8.96258 4.33789 3.92578 9.37469 3.92578 15.5879C3.92578 21.8011 8.96258 26.8379 15.1758 26.8379Z" stroke="#212121" strokeWidth="2" strokeLinecap="round" stroke-linejoin="round" />
                                  <path d="M13.9258 10.5879V16.8379H20.1758" stroke="#212121" strokeWidth="2" strokeLinecap="round" stroke-linejoin="round" />
                                </svg>
                                <p className="text-sm lg:text-base" >{getTime(item.seconds)} Min</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        {crrSurveyId === item.surveyId ?

                          <div className="w-8 h-8 rounded-full bg-[#2196f3] items-center justify-center flex text-white flex-shrink-0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-check"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M5 12l5 5l10 -10" /></svg>
                          </div>

                          :
                          <div className="w-8 h-8 rounded-full border-2 border-[#212121]/80 items-center justify-center flex-shrink-0   ">

                          </div>
                        }

                      </div>
                    )}
                  </>
                )
                : null}

              {/* */}

            </div>
          </div>


          <div className="h-20" />

          <div className="w-full py-3 bg-white/40 backdrop-blur-xl border-t fixed bottom-0 right-0 flex items-center">
            <div className=" 2xl:w-6/12 lg:w-8/12 w-full lg:px-0 px-4  gap-4 mx-auto  flex md:flex-row flex-row justify-between items-center ">
              <p className="text-sm text-[#212121] w-fit flex justify-center items-center"> © Powered by <b className="ml-1 font-medium text-[#212121]">HappyPlus </b></p>
              {showContinue === 1 ?
                <button onClick={() => handleTestClick()} className="md:w-60 w-fit  uppercase md:text-base text-base font-medium rounded-md    items-center justify-center md:px-4 px-8  py-3 cursor-pointer hover:bg-[#1976d2] transition-all duration-100 bg-[#2196f3] text-white lg:mr-3">
                  Continue
                </button>
                : null}
              {showContinue === 2 ?
                <button onClick={() => handleViewReport()} className="md:w-60 w-fit  uppercase md:text-base text-base font-medium rounded-md     items-center justify-center md:px-4 px-8  py-3 cursor-pointer  bg-[#2196f3] hover:bg-[#1976d2] transition-all duration-100 text-white overflow-hidden lg:mr-3">
                  Generate Report
                </button>
                : null}
            </div>

          </div>

        </section>
      </div>

    </>
  );
}
